function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M42.48 79.519c20.535 0 37.183-16.648 37.183-37.184 0-20.536-16.648-37.183-37.184-37.183-20.536 0-37.183 16.647-37.183 37.183S21.943 79.52 42.479 79.52z",
  fill: "#0081C6"
});

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "logo-dark_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 85,
  height: 85
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo-dark_svg__pattern0)",
  d: "M0 0h84.718v84.718H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#logo-dark_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.75,
  d: "M42.48 79.519c20.535 0 37.183-16.648 37.183-37.184 0-20.536-16.648-37.183-37.184-37.183-20.536 0-37.183 16.647-37.183 37.183S21.943 79.52 42.479 79.52z",
  fill: "#fff"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M42.478 74.82c17.941 0 32.485-14.544 32.485-32.485 0-17.94-14.544-32.485-32.485-32.485-17.94 0-32.485 14.544-32.485 32.485S24.537 74.82 42.478 74.82z",
  fill: "#000"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.66 34.798h4.293c.501 0 1.002.024 1.503.096.5.071.954.215 1.36.43.405.214.715.5.977.882.239.381.382.882.382 1.502 0 .644-.19 1.193-.549 1.622-.357.43-.834.74-1.43.93v.024c.38.048.715.167 1.025.31.31.167.572.358.787.596.215.239.382.525.5.86.12.333.168.667.168 1.049 0 .596-.12 1.12-.382 1.526-.262.405-.596.74-1.002.978-.405.238-.882.43-1.383.525a6.801 6.801 0 01-1.526.166H23.66V34.798zm2.552 4.604h1.837c.19 0 .381-.024.572-.072.19-.048.358-.12.501-.215.143-.095.262-.238.358-.381.095-.167.143-.358.143-.596 0-.239-.048-.43-.143-.597a.841.841 0 00-.406-.357c-.167-.096-.357-.144-.548-.191-.215-.048-.406-.048-.596-.048h-1.718v2.457zm0 4.77h2.266c.19 0 .382-.024.596-.072.191-.047.382-.119.549-.238.167-.12.286-.239.405-.43.096-.166.144-.381.144-.644 0-.262-.072-.5-.215-.667a1.557 1.557 0 00-.501-.382 3.076 3.076 0 00-.668-.19c-.238-.025-.453-.048-.668-.048h-1.908v2.67zM48.632 34.798h2.099l5.008 11.52h-2.862l-1.002-2.432h-4.483l-.955 2.432h-2.79l4.985-11.52zm.978 3.34l-1.407 3.577h2.814l-1.407-3.578zM56.455 37.04h-3.291v-2.242h9.11v2.242h-3.29v9.278h-2.529V37.04z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M38.901 46.652a6.034 6.034 0 100-12.068 6.034 6.034 0 000 12.068z",
  fill: "#0081C6"
});

var _ref7 = /*#__PURE__*/React.createElement("mask", {
  id: "logo-dark_svg__b",
  maskUnits: "userSpaceOnUse",
  x: 28,
  y: 29,
  width: 22,
  height: 23
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo-dark_svg__pattern1)",
  d: "M28.049 29.766h21.752v21.752H28.049z"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#logo-dark_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.75,
  d: "M38.901 46.652a6.034 6.034 0 100-12.068 6.034 6.034 0 000 12.068z",
  fill: "#fff"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M38.902 44.434a3.816 3.816 0 100-7.632 3.816 3.816 0 000 7.632z",
  fill: "#000"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M26.118 50.015a1.752 1.752 0 00-.835-.572c-.358-.12-.692-.19-1.002-.19a2.352 2.352 0 00-1.12.285 1.56 1.56 0 00-.43.358c-.12.143-.167.334-.167.549 0 .357.119.62.381.787.263.19.597.334.978.477.406.119.811.262 1.288.381.453.12.883.31 1.288.549.406.238.716.548.978.954.262.405.382.93.382 1.622 0 .644-.12 1.192-.358 1.67a3.417 3.417 0 01-.978 1.192c-.405.31-.882.549-1.407.692a6.597 6.597 0 01-1.694.238c-.739 0-1.43-.12-2.075-.334a5.417 5.417 0 01-1.788-1.097l1.812-1.98c.263.358.597.62.978.811.406.191.811.287 1.217.287.214 0 .405-.024.62-.072.214-.048.405-.12.572-.215a1.04 1.04 0 00.406-.381.988.988 0 00.143-.549.943.943 0 00-.406-.81 3.28 3.28 0 00-1.002-.502 28.521 28.521 0 00-1.311-.429 5.901 5.901 0 01-1.312-.572 2.947 2.947 0 01-1.002-.954c-.262-.382-.405-.907-.405-1.55 0-.62.119-1.17.357-1.623.239-.477.573-.858.978-1.168.406-.31.883-.549 1.407-.716a5.387 5.387 0 011.646-.238 6.22 6.22 0 011.884.286c.597.19 1.145.5 1.646.93l-1.67 1.884zM28.455 47.2h2.528v4.294h4.937v-4.293h2.528v11.52H35.92v-4.985h-4.937v4.985h-2.528V47.2zM50.064 47.2h2.767l1.836 7.395h.024L57.1 47.2h2.361l2.385 7.584h.024l1.932-7.584h2.576l-3.363 11.52h-2.266l-2.528-7.966h-.024L55.67 58.72h-2.17L50.063 47.2z",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M44.984 59.055a6.034 6.034 0 100-12.069 6.034 6.034 0 000 12.069z",
  fill: "#0081C6"
});

var _ref12 = /*#__PURE__*/React.createElement("mask", {
  id: "logo-dark_svg__c",
  maskUnits: "userSpaceOnUse",
  x: 33,
  y: 41,
  width: 24,
  height: 24
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo-dark_svg__pattern2)",
  d: "M33.774 41.787h22.324v22.324H33.774z"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#logo-dark_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.75,
  d: "M44.984 59.055a6.034 6.034 0 100-12.069 6.034 6.034 0 000 12.069z",
  fill: "#fff"
}));

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M44.985 56.837a3.816 3.816 0 100-7.633 3.816 3.816 0 000 7.633z",
  fill: "#000"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M35.204 27.357h1.813l-.12.835h.024c.072-.12.167-.239.31-.358.12-.12.263-.215.43-.31a1.88 1.88 0 01.548-.215c.191-.047.406-.095.644-.095.477 0 .859.071 1.121.215.286.143.477.357.596.62.12.262.191.572.191.906 0 .358-.024.74-.071 1.145l-.453 3.363h-1.885l.406-2.982c.024-.167.047-.357.071-.548.024-.191 0-.358-.047-.525a.702.702 0 00-.239-.382c-.12-.095-.286-.143-.548-.143-.239 0-.454.048-.62.143a1.458 1.458 0 00-.406.358 1.59 1.59 0 00-.215.501c-.047.19-.095.382-.119.573l-.43 3.053h-1.883l.882-6.154zM41.907 23.946h1.884l-1.336 9.493h-1.884l1.336-9.493zM43.694 27.357h1.884l-.858 6.106h-1.885l.86-6.106zm.12-1.932a1.52 1.52 0 01.142-.43.972.972 0 01.287-.333c.119-.096.238-.167.381-.239.143-.047.286-.095.43-.095.31 0 .548.095.715.31.19.215.239.477.215.763a1.513 1.513 0 01-.143.43.97.97 0 01-.287.333c-.119.096-.238.167-.381.239a1.393 1.393 0 01-.43.095.784.784 0 01-.405-.095.775.775 0 01-.31-.239.935.935 0 01-.19-.334c-.025-.119-.049-.262-.025-.405zM45.937 27.357h1.812l-.119.835h.024c.071-.12.167-.239.31-.358.12-.12.262-.215.43-.31.166-.096.333-.167.548-.215.19-.047.405-.095.644-.095.477 0 .858.071 1.12.215.287.143.478.357.597.62.12.262.19.572.19.906 0 .358-.023.74-.07 1.145l-.454 3.363h-1.884l.405-2.982c.024-.167.048-.357.072-.548.024-.191 0-.358-.048-.525a.702.702 0 00-.238-.382c-.12-.095-.286-.143-.549-.143-.238 0-.453.048-.62.143a1.459 1.459 0 00-.405.358 1.59 1.59 0 00-.215.501c-.048.19-.095.382-.12.573l-.429 3.053h-1.884l.883-6.154zM57.194 32.413c-.357.382-.763.692-1.264.883-.5.214-.978.31-1.478.31-.477 0-.907-.072-1.288-.215a2.341 2.341 0 01-.978-.644 2.617 2.617 0 01-.573-1.002c-.119-.381-.143-.834-.071-1.311.071-.477.214-.93.453-1.312.238-.406.525-.74.858-1.002.334-.286.74-.5 1.17-.644.428-.143.882-.214 1.359-.214.429 0 .81.071 1.145.214.333.143.596.358.81.644.215.286.358.62.43 1.002.071.405.095.835.024 1.312l-.096.596h-4.364c.023.358.143.644.381.859.215.214.525.31.883.31.31 0 .572-.072.81-.215.239-.143.454-.31.645-.525l1.144.954zm-1.24-2.695a1.044 1.044 0 00-.19-.81c-.192-.216-.454-.335-.788-.335-.214 0-.405.024-.572.096a1.3 1.3 0 00-.43.262c-.119.095-.238.215-.31.358a1.072 1.072 0 00-.166.43h2.456z",
  fill: "#fff"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M31.389 33.582a3.244 3.244 0 100-6.488 3.244 3.244 0 000 6.488z",
  fill: "#fff"
});

var _ref17 = /*#__PURE__*/React.createElement("mask", {
  id: "logo-dark_svg__d",
  maskUnits: "userSpaceOnUse",
  x: 22,
  y: 22,
  width: 18,
  height: 17
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo-dark_svg__pattern3)",
  d: "M22.898 22.324h16.6v16.6h-16.6z"
}));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#logo-dark_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.75,
  d: "M31.389 33.582a3.244 3.244 0 100-6.488 3.244 3.244 0 000 6.488z",
  fill: "#fff"
}));

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M31.388 31.912a1.574 1.574 0 100-3.148 1.574 1.574 0 000 3.148z",
  fill: "#000"
});

var _ref20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "logo-dark_svg__pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-dark_svg__image0"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "logo-dark_svg__pattern1",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-dark_svg__image0"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "logo-dark_svg__pattern2",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-dark_svg__image0"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "logo-dark_svg__pattern3",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#logo-dark_svg__image0"
})), /*#__PURE__*/React.createElement("image", {
  id: "logo-dark_svg__image0",
  xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEBLAEsAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA"
}));

function SvgLogoDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
}

export default __webpack_public_path__ + "static/logo-dark.94d7fa22.svg";
export { SvgLogoDark as ReactComponent };